const noop = () => {};

const isLocalEnvironment = () => {
  if (process.env.NODE_ENV === 'development') return true;

  if (typeof window === 'undefined') return false;

  const hostname = window.location.hostname;
  return hostname === 'localhost' || hostname === '127.0.0.1' || hostname === '0.0.0.0';
};

export const setupConsoleSilencing = () => {
  if (isLocalEnvironment()) return;

  console.log = noop;
  console.info = noop;
  console.debug = noop;
  console.warn = noop;
  console.error = noop;
};
